import { inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import type { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, firstValueFrom } from 'rxjs';
import { DealerFeature } from '../+state';
import type { Dealer } from '../api/api-types';
import { isHCM, isHWS } from '../providers/platform.token';

export interface MetaData {
    description: string;
}

/**
 * Wenn mehr Daten als nur der Dealer zum erstellen der Meta Daten gebraucht werden
 */
export function createMetaResolver(
    metaData: (store: Store, isHWS: boolean) => Promise<MetaData> | MetaData,
): ResolveFn<MetaData> {
    return async () => {
        const meta = inject(Meta);
        const store = inject(Store);
        return createMetaData(await metaData(store, isHWS()), meta);
    };
}

export function createMetaResolverWithDealer(
    metaData: (dealer: Dealer, store: Store) => Promise<MetaData> | MetaData,
): ResolveFn<MetaData> {
    return async () => {
        const meta = inject(Meta);
        const store = inject(Store);
        if (isHCM()) {
            console.error("createMetaResolverWithDealer can't  be used in vehicle market");
        }

        const dealer = await firstValueFrom(
            store.select(DealerFeature.state.selectLoadedDealer).pipe(filter((d) => !!d)),
        );
        return createMetaData(await metaData(dealer, store), meta);
    };
}

export function createMetaData(data: { description: string }, meta: Meta) {
    meta.removeTag("name='description'");
    meta.addTag({ name: 'description', content: data.description });

    return data;
}
